import { Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';

@Injectable()
export class NotificationService {
  private readonly successTimeout = 10e3;
  private readonly errorTimeout = 86400e3;

  constructor() {}

  success(message: string): void {
    this.show(message, 'success', this.successTimeout);
  }

  error(message: string): void {
    this.show(message, 'error', this.errorTimeout);
  }

  private show(message: string, type: string, timeout: number): void {
    notify(
      {
        message: message,
        position: {
          my: 'center top',
          at: 'center top'
        },
        width: function() {
          return window.innerWidth / 2;
        }
      },
      type,
      timeout
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/notification/notification.service.ts